import { Component } from '@angular/core';
import { DataBoxComponent } from '@shared/components/data-box/data-box.component';
import { DataItem } from '@shared/models/data-item';

@Component({
    selector: 'app-sequence-total-info',
    imports: [DataBoxComponent],
    templateUrl: './sequence-total-info.component.html',
    styleUrl: './sequence-total-info.component.scss'
})
export class SequenceTotalsInfoComponent {

  titleDeadhead = "Deadhead";
  titleFlight = "Flight";
  titleTotal = "Total";
  titleTAFB = "TAFB";
  
  dataItemFlight: DataItem[] = [
    {
      label: "",
      value: `This is the total actual flight time for the current sequence displayed 
      in hours and minutes.  Does not include deadheads or cancelled flights,
      only actual flight time.`
    }
  ];
  
  dataItemDeadhead: DataItem[] = [
    {
      label: "",
      value: `This is the total of all deadhead or positioning flight time for the 
      current sequence displayed in hours and minutes.`
    }
  ];
  
  
  dataItemTotal: DataItem[] = [
    {
      label: "",
      value: `This is the sum flight and deadhead time for the current sequence displayed 
      in hours and minutes.`
    }
  ];

  dataItemTAFB: DataItem[] = [
    {
      label: "",
      value: `Time Away From Base (TAFB) is based on sign in time from the first duty period to the final
      leg IN time plus 15 minutes domestic or 30 minutes international devbrief time.`
    }
  ]
}
